/** 물리적조성 조성행(종이류 등). 시험일지 UI 전용 — categoryForm 측정항목에서 제외. */
export const disposalPhysCompositionRowNames = [
	'종이류',
	'섬유류',
	'음식물류',
	'나무류',
	'정원 및 공원폐기물류',
	'고무 및 피혁류',
	'기저귀',
	'플라스틱류',
	'금속류',
	'유리류',
	'기타생활폐기물'
]

/**
 * 폐기물 물리적조성 시험항목 testId 정본.
 * - DISPOSAL_TEST_134: 물리적조성(소각)
 * - DISPOSAL_TEST_145: 물리적조성(매립)
 * - DISPOSAL_TEST_156: 물리적조성(공사현장)
 * ⚠️ 069~071 은 물리적조성이 아니라 할로겐화유기화합물(055)의 VOCs 자식이므로 무관.
 */
export const disposalPhysCompositionTestIds = [
	'DISPOSAL_TEST_134',
	'DISPOSAL_TEST_145',
	'DISPOSAL_TEST_156'
]

/**
 * 물리적조성(공사현장, DISPOSAL_TEST_156)
 * - 가연성/비가연성: 검색·추가(동적)
 * - 토사류 (2mm 이하)·가연성 합계·비가연성 합계·총계: 항상 존재(토사류는 가연성과 동일 depth)
 */
export const disposalPhysCompositionConstTestId = 'DISPOSAL_TEST_156'
export const disposalPhysCompositionConstGroups = ['가연성', '비가연성', '토사류']
/** 공사현장 — 동적 추가 가능한 구분(토사류는 고정행, 선택 불가) */
export const disposalPhysCompositionConstSelectableGroups = ['가연성', '비가연성']
/** 공사현장 조성항목명 — 시료등록·categoryForm 방어 필터용 */
export const disposalPhysCompositionConstRowNames = [
	'폐스티로폼',
	'폐비닐/플라스틱',
	'폐목재',
	'폐섬유',
	'폐고무',
	'폐도자기류',
	'고철류',
	'폐유리류',
	'건설폐기물',
	'기타',
	'토사류(2mm 이하)',
	'토사류 (2mm 이하)',
]
export const disposalPhysCompositionExcludedRowNames = [
	...disposalPhysCompositionRowNames,
	...disposalPhysCompositionConstRowNames,
]
/** 실측 시트 슬롯 참고(가연성6/비가연성5/토사류1). UI는 검색·선택으로 동적 추가. */
export const disposalPhysCompositionConstRows = [
	{ group: '가연성', category: '폐스티로폼' },
	{ group: '가연성', category: '폐비닐/플라스틱' },
	{ group: '가연성', category: '폐목재' },
	{ group: '가연성', category: '폐섬유' },
	{ group: '가연성', category: '폐고무' },
	{ group: '가연성', category: '기타' },
	{ group: '비가연성', category: '폐도자기류' },
	{ group: '비가연성', category: '고철류' },
	{ group: '비가연성', category: '폐유리류' },
	{ group: '비가연성', category: '건설폐기물' },
	{ group: '비가연성', category: '기타' },
	{ group: '토사류', category: '토사류 (2mm 이하)' },
]
/** 공사현장 검색 옵션 — group 으로 가연성/비가연성 필터(토사류는 고정행) */
export const disposalPhysCompositionConstOptions = [
	{ text: '폐스티로폼', value: '폐스티로폼', group: '가연성' },
	{ text: '폐비닐/플라스틱', value: '폐비닐/플라스틱', group: '가연성' },
	{ text: '폐목재', value: '폐목재', group: '가연성' },
	{ text: '폐섬유', value: '폐섬유', group: '가연성' },
	{ text: '폐고무', value: '폐고무', group: '가연성' },
	{ text: '기타', value: '기타', group: '가연성' },
	{ text: '폐도자기류', value: '폐도자기류', group: '비가연성' },
	{ text: '고철류', value: '고철류', group: '비가연성' },
	{ text: '폐유리류', value: '폐유리류', group: '비가연성' },
	{ text: '건설폐기물', value: '건설폐기물', group: '비가연성' },
	{ text: '기타', value: '기타', group: '비가연성' },
]

/**
 * hide_parent_id 부모 ID. 문구 미리보기·categoryForm 그룹 부모 노출에 사용.
 * DISPOSAL 채번은 운영 DB(etps) 기준.
 * ※ 2026-07-17: 시료등록 그리드의 그룹 노출은 release(토양·수질) 규칙으로 복원 —
 *   모든 그룹 부모 노출 + 그룹 토글 시 하위 연동. 이 목록은 hideGroup형 부모
 *   (하위 is_document_hide=1 숨김 유지: 유기인 013·할로겐화 085·삼성분 116 등)
 *   강제 노출 보장에만 사용된다.
 */
export const includeParentIds = [
	'SOIL_TEST_016',
	'SOIL_TEST_013',
	'WATER_TEST_010',
	'WATER_TEST_179',
	'DISPOSAL_TEST_013', // 유기인 — 부모만 선택, 하위 숨김
	'DISPOSAL_TEST_085', // 할로겐화유기물질 — 부모만 선택, 하위 숨김
	'DISPOSAL_TEST_116', // 삼성분 — 부모만 선택, 하위 숨김
	// DISPOSAL_TEST_120 발열량 / DISPOSAL_TEST_124 원소분석 / DISPOSAL_TEST_131 Cl,S:
	// 부모는 일지·성적서 그룹용. 시료등록에서는 하위만 노출(040형).
]

/**
 * 시료등록 그룹 부모 노출 대상 판정.
 * includeParentIds 화이트리스트에 있고, 그룹(자식 보유)이거나 hideGroup 부모인 항목.
 * API 가 자식(parent_id) 미연결로 type:'test' 만 주는 경우에도 부모를 옵션/열에 유지한다.
 * (headers 는 `hide_type`, testList 는 `hideType` 로 필드명이 달라 둘 다 확인)
 */
export function isSpecimenParentItem(item) {
	if (!item) return false
	const tid = item.testId || item.id
	if (!tid || !includeParentIds.includes(tid)) return false
	return (
		item.type === 'group' ||
		item.hide_type === 'hideGroup' ||
		item.hideType === 'hideGroup'
	)
}

/** DB/API별 0/1 표현을 엄격한 boolean으로 정규화한다. */
export function isContactHidden(itemOrValue) {
	const value = itemOrValue && typeof itemOrValue === 'object'
		? (itemOrValue.is_contact_hide ?? itemOrValue.contact_hide)
		: itemOrValue
	return value === true || value === 1 || value === '1'
}

function isBaseVisibleSpecimenHeader(item, { category } = {}) {
	if (!item) return false

	const isHiddenChild = item.is_document_hide === 1 && item.hide_parent_id
	const isCompletelyHidden =
		item.is_document_hide === 1 && item.is_report_hide === 1
	const isCompositionRow =
		category === 'DISPOSAL' &&
		disposalPhysCompositionExcludedRowNames.includes(item.name)
	if (isHiddenChild || isCompletelyHidden || isCompositionRow) return false

	// contact 숨김보다 우선하면 안 되므로 부모 화이트리스트는 base 판정에서만 적용한다.
	if (isSpecimenParentItem(item)) return true

	// 그룹 부모는 토양·수질 정본(release)과 동일하게 항상 노출한다.
	// 그룹 토글 시 하위 연동은 specimen.vue 공용 로직(type==='group' → parent_id 전파)이 담당.
	return true
}

/**
 * 전체 시험항목 관계를 기준으로 UI 가시성을 계산한다.
 * contact 숨김은 parent_id/hide_parent_id 후손에 상속하며, 원본 배열은 변경하지 않는다.
 */
export function buildSpecimenVisibilityMap(items, { category } = {}) {
	const list = Array.isArray(items) ? items.filter(Boolean) : []
	const itemById = new Map()
	const childrenByParent = new Map()

	list.forEach((item) => {
		const id = item.testId || item.id
		if (!id) return
		const key = String(id)
		itemById.set(key, item)
		const parentIds = [item.parent_id, item.hide_parent_id]
			.filter(parentId => parentId != null && parentId !== '')
			.map(String)
		parentIds.forEach((parentId) => {
			if (parentId === key) return
			if (!childrenByParent.has(parentId)) childrenByParent.set(parentId, new Set())
			childrenByParent.get(parentId).add(key)
		})
	})

	const directHiddenIds = new Set()
	itemById.forEach((item, id) => {
		if (isContactHidden(item)) directHiddenIds.add(id)
	})

	const inheritedHiddenIds = new Set()
	const queue = [...directHiddenIds]
	const visited = new Set(queue)
	while (queue.length > 0) {
		const parentId = queue.shift()
		const children = childrenByParent.get(parentId)
		if (!children) continue
		children.forEach((childId) => {
			if (!directHiddenIds.has(childId)) inheritedHiddenIds.add(childId)
			if (!visited.has(childId)) {
				visited.add(childId)
				queue.push(childId)
			}
		})
	}

	const result = new Map()
	itemById.forEach((item, id) => {
		const directContactHidden = directHiddenIds.has(id)
		const inheritedContactHidden = inheritedHiddenIds.has(id)
		const contactHidden = directContactHidden || inheritedContactHidden
		const baseVisible = isBaseVisibleSpecimenHeader(item, { category })
		result.set(id, {
			visible: !contactHidden && baseVisible,
			contactHidden,
			directContactHidden,
			inheritedContactHidden,
			reason: directContactHidden
				? 'contact'
				: inheritedContactHidden
					? 'contact-parent'
					: baseVisible
						? null
						: 'base-rule'
		})
	})
	return result
}

/**
 * 시료등록(specimen) 측정항목 헤더/옵션 노출 판정.
 * 토양/수질 유기인 정본과 동일 규칙:
 *  - 화이트리스트 부모(includeParentIds)는 항상 노출
 *  - 숨김 자식(is_document_hide=1 + hide_parent_id)·완전 숨김·물리적조성 조성행 제거
 *  - 화이트리스트 미포함 그룹 부모(040형)는 숨김(하위만 개별 선택)
 */
export function isVisibleSpecimenHeader(item, { category, visibilityMap } = {}) {
	if (!item) return false
	const tid = item.testId || item.id
	if (visibilityMap && tid != null) {
		const status = visibilityMap.get(String(tid))
		if (status) return status.visible
	}
	if (isContactHidden(item)) return false
	return isBaseVisibleSpecimenHeader(item, { category })
}

const options = {
	//권한 (선택 UI용). CS_SUB_ADMIN 은 화면에서 숨김 — 기존 계정 표시는 permissionText 사용.
	permission: [
		{ text: '관리자', value: 'ADMIN' },
		{ text: '서브관리자', value: 'SUB_ADMIN' },
		{ text: 'CS관리자', value: 'CS_ADMIN' },
		{ text: '기술책임자', value: 'TECH_ADMIN' },
		{ text: '실무자', value: 'TECH' },
		{ text: 'CS', value: 'CS' }
	],
	/** 선택 목록에서 숨길 역할 (매트릭스 열·필터·등록 select 공통) */
	permissionHiddenFromUi: ['CS_SUB_ADMIN'],
	//시험부서
	anaDeptOptions: [
		{ text: '토양분석팀', value: 'SOIL' },
		{ text: '수질분석팀', value: 'WATER' },
		{ text: '대기분석팀', value: 'AIR' },
		{ text: '폐기물분석팀', value: 'DISPOSAL' }
	],
	//담당자
	managerSample: [
		{ text: '정동주', value: '정동주' },
		{ text: '김은혜', value: '김은혜' }
	],
	//시료 수령 방법
	deliveryWaySample: [
		{ text: '방문 채취', value: '방문 채취' },
		{ text: '지참 시료', value: '지참 시료' }
	],
	//업무구분
	typeSample: [
		{ text: '토양(개발테스트)', value: 'EA' },
		{ text: '수질(개발테스트)', value: 'EL' },
		{ text: '대기(개발테스트)', value: 'EE' },
		{ text: '폐기물(개발테스트)', value: 'EK' }
	],
	//시료용기
	sampleContainerSample: [
		{ text: 'PET', value: 'PET' },
		{ text: 'VIAL', value: 'VIAL' },
		{ text: '광구병', value: '광구병' },
		{ text: '마대', value: '마대' },
		{ text: '지퍼백,갈색유리병', value: '지퍼백,갈색유리병' }
	],
	//시험방법
	testMethodSample: [
		{ text: '토양오염공정시험기준', value: '토양오염공정시험기준' },
		{ text: '토양이화학분석법', value: '토양이화학분석법' }
	],
	//unit
	unitOption: [
		{ text: 'mg/L', value: 'mg/L' },
		{ text: 'mL', value: 'mL' },
		{ text: '%', value: '%' },
		{ text: 'g', value: 'g' },
		{ text: 'mg/kg', value: 'mg/kg' },
		{ text: 'mg/m³', value: 'mg/m³' },
		{ text: 'ng', value: 'ng' },
		{ text: 'ug/L', value: 'ug/L' },
		{ text: 'Cps', value: 'Cps' },
		{ text: 'Area', value: 'Area' }
	],
	//옵션 샘플
	optionsSample: [
		{ text: '샘플 옵션 1번', value: 'option1' },
		{ text: '샘플 옵션 2번', value: 'option2' },
		{ text: '샘플 옵션 3번', value: 'option3' },
		{ text: '샘플 옵션 4번', value: 'option4' }
	],
	// 업무구분 코드(docType)는 project_type_code 테이블 + GET /project/filter/list 로 관리.
	// Admin: GET/POST/DELETE /admin/project-type-code
	useFor: [
		{ text: '제출용(감리단)', value: '제출용(감리단)' },
		{ text: '제출용', value: '제출용' },
		{ text: '정밀조사', value: '정밀조사' },
		{ text: '품질관리용', value: '품질관리용' },
		{ text: '토양조사용', value: '토양조사용' },
		{ text: '참고용', value: '참고용' },
		{
			text: '제출용(수도권매립지관리공사)',
			value: '제출용(수도권매립지관리공사)'
		},
		{ text: '자체조사', value: '자체조사' },
		{ text: '개황조사', value: '개황조사' },
		{
			text: '참고용 (정화검증 사전검사)',
			value: '참고용 (정화검증 사전검사)'
		},
		{ text: '정화검증', value: '정화검증' },
		{ text: '과정검증', value: '과정검증' },
		{ text: '실태조사', value: '실태조사' },
		{ text: '자체현황조사', value: '자체현황조사' },
		{
			text: '참고용(환경영향평가 기초자료)',
			value: '참고용(환경영향평가 기초자료)'
		},
		{ text: '정화 모니터링', value: '정화 모니터링' },
		{ text: '사후환경평가', value: '사후환경평가' },
		{ text: '토양환경평가', value: '토양환경평가' },
		{ text: '어린이용품의 환경진단', value: '어린이용품의 환경진단' },
		{ text: '재검증', value: '재검증' },
		{ text: '자체정밀조사', value: '자체정밀조사' },
		{ text: '보도용', value: '보도용' },
		{ text: '실시설계', value: '실시설계' },
		{ text: '연구실험용', value: '연구실험용' },
		{ text: '환경영향평가용', value: '환경영향평가용' },
		{ text: '토양개황 및 정밀조사', value: '토양개황 및 정밀조사' },
		{ text: '자체조사(준정밀조사)', value: '자체조사(준정밀조사)' },
		{ text: '참고', value: '참고' },
		{ text: '정화검증(굴착공정)', value: '정화검증(굴착공정)' },
		{ text: '토양개황조사', value: '토양개황조사' },
		{ text: '정화검증(1차 과정검증)', value: '정화검증(1차 과정검증)' },
		{ text: '수처리장 모니터링', value: '수처리장 모니터링' },
		{ text: '추가정밀조사', value: '추가정밀조사' },
		{ text: '자체토양정밀조사', value: '자체토양정밀조사' },
		{ text: '완료검증', value: '완료검증' },
		{
			text: '폐기물분석기관지정 신청용',
			value: '폐기물분석기관지정 신청용'
		},
		{ text: '추가 정밀조사', value: '추가 정밀조사' },
		{ text: '과정검증(굴착공정)', value: '과정검증(굴착공정)' },
		{ text: '과정검증(굴착검증)', value: '과정검증(굴착검증)' },
		{ text: '성적서 보관용', value: '성적서 보관용' },
		{ text: '환경관련 보조자료', value: '환경관련 보조자료' },
		{ text: '완료검증(굴착공정)', value: '완료검증(굴착공정)' },
		{ text: '저수조 수질검사', value: '저수조 수질검사' },
		{ text: '토양환경평가(개황조사)', value: '토양환경평가(개황조사)' },
		{ text: '내부참고용', value: '내부참고용' },
		{ text: '환경영향평가', value: '환경영향평가' },
		{ text: '법정검사', value: '법정검사' },
		{ text: '모래안전검사', value: '모래안전검사' },
		{
			text: '기타(어린지 놀이시설 바닥재 관리)',
			value: '기타(어린지 놀이시설 바닥재 관리)'
		},
		{ text: '굴착검증', value: '굴착검증' },
		{ text: '사후환경영향조사', value: '사후환경영향조사' },
		{ text: '오염범위확인조사', value: '오염범위확인조사' },
		{ text: '제출용(감정평가용)', value: '제출용(감정평가용)' },
		{ text: '감정평가', value: '감정평가' },
		{ text: '내부정도관리', value: '내부정도관리' },
		{ text: '오염조사', value: '오염조사' },
		{ text: '토양환경평가(정밀조사)', value: '토양환경평가(정밀조사)' },
		{ text: '픔질관리용', value: '픔질관리용' },
		{ text: '제츨용', value: '제츨용' },
		{ text: '환경영향평가용(개황조사)', value: '환경영향평가용(개황조사)' },
		{ text: '품질시험용', value: '품질시험용' },
		{ text: '정기검사', value: '정기검사' },
		{ text: '교차검증', value: '교차검증' },
		{ text: '토양환경평가', value: '토양환경평가' },
		{ text: '(정밀조사)', value: '(정밀조사)' },
		{ text: '오염원인자규명', value: '오염원인자규명' },
		{ text: '자가측정용', value: '자가측정용' },
		{ text: '전략환경영향평가', value: '전략환경영향평가' },
		{ text: '정밀(상세)조사', value: '정밀(상세)조사' },
		{ text: '자체확인용', value: '자체확인용' },
		{ text: '참고용/품질관리용', value: '참고용/품질관리용' },
		{ text: '개황 및 정밀조사', value: '개황 및 정밀조사' },
		{ text: '법정검사(정기검사)', value: '법정검사(정기검사)' },
		{ text: '법정검사용', value: '법정검사용' },
		{ text: '토양정밀(개황)조사', value: '토양정밀(개황)조사' },
		{ text: '수질조사', value: '수질조사' },
		{
			text: '토양정밀(개황 및 상세)조사',
			value: '토양정밀(개황 및 상세)조사'
		},
		{ text: '기술진단', value: '기술진단' },
		{ text: '토양정밀(상세)조사', value: '토양정밀(상세)조사' },
		{ text: '사후환경영향조사용', value: '사후환경영향조사용' },
		{ text: '정밀(개황)조사', value: '정밀(개황)조사' },
		{ text: '소규모환경영향평가', value: '소규모환경영향평가' },
		{ text: '유통기한연장신청용', value: '유통기한연장신청용' },
		{ text: '법원감정용', value: '법원감정용' },
		{ text: '오염현황조사', value: '오염현황조사' },
		{ text: '현장검증', value: '현장검증' },
		{ text: '토양오염추가조사', value: '토양오염추가조사' },
		{ text: '보완조사', value: '보완조사' },
		{ text: '사후환경영향평가', value: '사후환경영향평가' },
		{ text: '모니터링', value: '모니터링' },
		{ text: '사후환경영향평가용', value: '사후환경영향평가용' },
		{ text: '소규모 환경영향평가용', value: '소규모 환경영향평가용' },
		{ text: '토양오염 현황조사', value: '토양오염 현황조사' },
		{ text: '기타(실험용)', value: '기타(실험용)' },
		{ text: '토양환경평가', value: '토양환경평가' },
		{ text: '감정평가용', value: '감정평가용' },
		{ text: '사후모니터링', value: '사후모니터링' },
		{ text: '전략환경영향평가용', value: '전략환경영향평가용' },
		{ text: '토양정밀조사', value: '토양정밀조사' },
		{
			text: '사후환경영향조사(철거 전)',
			value: '사후환경영향조사(철거 전)'
		},
		{ text: '용도 텍스트', value: '용도 텍스트' },
		{ text: '토지 검사용 ', value: '토지 검사용 ' },
		{ text: '토양(개발테스트)', value: '토양(개발테스트)' }
	],
	cvvType: [
		{ text: 'ABS', value: 'ABS' },
		{ text: '흡광도', value: '흡광도' },
		{ text: '농도', value: '농도' },
		{ text: 'CPS', value: 'CPS' },
		{ text: 'area', value: 'area' },
		{ text: 'mg/L', value: 'mg/L' },
		{ text: '농도(mg/L)', value: '농도(mg/L)' }
	],
	bank: [
		//2026.01.28 일부 은행만 사용
		{ text: '국민은행', value: '국민은행' },
		{ text: '농협은행', value: '농협은행' },
		{ text: '신한은행', value: '신한은행' },
		{ text: '우리은행', value: '우리은행' },
		{ text: 'KEB하나은행', value: 'KEB하나은행' },
	],
	criteriaOptions: [
		{ text: '지하수법 시행규칙', value: 'criteria1' },
		{ text: '먹는물 수질기준 및 검사등에 관한 규칙', value: 'criteria2' },
		{
			text: '물환경보전법 시행규칙 [별표 13] 수질오염물질의 배출허용기준(제34조 관련)',
			value: 'criteria3'
		},
		{ text: '먹는물 수질감시항목 운영 등에 관한 고시', value: 'criteria4' },
		{ text: '오염지하수 정화기준 - 지하수법 시행규칙', value: 'criteria5' },
		{ text: '물환경보전법 시행규칙 별표 13의2', value: 'criteria6' },
		{
			text: '물환경보전법 시행규칙 별표 10 - 공공폐수처리시설의 방류수 수질기준',
			value: 'criteria7'
		},
		{
			text: '물환경보전법 시행규칙 별표 10 - 농공단지 공공폐수처리시설의 방류수 수질기준',
			value: 'criteria8'
		},
		{ text: '하수도법 시행규칙 별표 1', value: 'criteria9' },
		{
			text: '폐기물관리법 시행규칙 별표11 - 폐기물 처분시설 또는 재활용시설의 관리기준(매립시설 침출수)',
			value: 'criteria10'
		},
		{
			text: '환경정책기본법 시행령 별표 1 - 환경기준: 수질 및 수생태계 사람의 건강보호 기준',
			value: 'criteria11'
		},
		{
			text: '수질오염물질 배출허용기준 중 별도배출허용기준 통합 지정 고시 (환경부고시 제2021-199호)',
			value: 'criteria12'
		}
	],
	includeParentIds,
	excludeTestIds: [
		'SOIL_TEST_150',
		'SOIL_TEST_151',
		'SOIL_TEST_152',
		'SOIL_TEST_153',
		'SOIL_TEST_154',
		'SOIL_TEST_155',
		'SOIL_TEST_156',
		'SOIL_TEST_157',
		'SOIL_TEST_158'
	],
	//이슈보드 분류 : 발행, 입금
	issueCategoryType: [
		{ text: '발행', value: 'PUBLISH' },
		{ text: '입금', value: 'PAID' }
	],
	// 헤더가 문서에 표시되어야 하는지 확인 (is_document_hide 기준)
	isVisibleHeader(header) {
		if (!header) return false
		return (
			header.is_document_hide !== 1 ||
			this.excludeTestIds.includes(header.testId)
		)
	},
	specificWaterNames: [
		'폼알데하이드', '페놀', '펜타클로로페놀', '1‚4-다이옥산',
		'에피클로로하이드린', '아크릴아미드', 'DEHP', '비스(2-에틸헥실)아디페이트',
		'유기인', 'PCB', '수은', '셀레늄', '시안', '6가크롬',
		'염화비닐', '1‚1-디클로로에틸렌', '디클로로메탄', '아크릴로니트릴',
		'클로로포름', '사염화탄소', '1‚2-디클로로에탄', '벤젠',
		'TCE', 'PCE', '나프탈렌', '스티렌',
		'브로모포름', '구리', '카드뮴', '납', '비소', '안티몬',
	],
	waterPheonolIds: ['WATER_TEST_027', 'WATER_TEST_102'],
	testHeaderSearchNameIds: [
		'WATER_TEST_027',
		'WATER_TEST_102',
		'DISPOSAL_TEST_045',
		'DISPOSAL_TEST_169'
	],
	permissionText: {
		ADMIN: '관리자',
		TECH: '실무자',
		TECH_ADMIN: '기술책임자',
		CS_SUB_ADMIN: 'CS 부관리자'
	},
	/** 시험 카테고리 코드 → 표시명 (권한 관리 등) */
	reportCategoryLabel: {
		SOIL: '토양',
		WATER: '수질',
		AIR: '대기',
		DISPOSAL: '폐기물'
	},
	/**
	 * 폐기물 물리적조성(소각·매립) 기본 조성항목 목록.
	 * 공사현장(156)은 disposalPhysCompositionConstOptions(가연성/비가연성/토사류) 사용.
	 *
	 * ⚠️ 이 목록은 시험일지(PhysCompositionForm.vue) 전용이며 시험항목이 아니다.
	 *    시료등록(specimen) 측정항목 목록에는 절대 노출되어선 안 된다
	 *    (→ disposalPhysCompositionRowNames 로 방어 필터).
	 */
	disposalPhysComposition: {
		default: disposalPhysCompositionRowNames.map(t => ({ text: t, value: t }))
	}
}

export default options